import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

// --- admin client with token ---
export const adminApi = axios.create({ baseURL: `${BACKEND_URL}/api` });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("fva_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getAdminToken = () => localStorage.getItem("fva_admin_token");
export const setAdminToken = (t) => localStorage.setItem("fva_admin_token", t);
export const clearAdminToken = () => localStorage.removeItem("fva_admin_token");
export const getBackendBase = () => `${BACKEND_URL}/api`;
